import { render, staticRenderFns } from "./retrieve-password.vue?vue&type=template&id=291f698f&"
import script from "@/model/password?vue&type=script&lang=js&"
export * from "@/model/password?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports